<template>
    <!-- Reusable animated ECG line. The brand cue for the "heartbeat"
         metaphor (Home teaser, Features deep-dive, store-buttons CTA).
         Decorative only (aria-hidden), the surrounding section
         provides the semantic context. -->
    <div
        class="heartbeat-pulse"
        aria-hidden="true"
    >
        <svg
            viewBox="0 0 240 60"
            xmlns="http://www.w3.org/2000/svg"
        >
            <polyline
                class="heartbeat-pulse__line"
                points="0,30 60,30 75,30 80,10 88,52 96,18 104,30 240,30"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'HeartbeatPulse',
}
</script>

<style lang="scss" scoped>
/* Defaults sized for the teaser/details usage (240x60). When dropped
   into a different surface (e.g. above the store buttons), the parent
   can override via .heartbeat-pulse { width: ... } in its own
   scoped styles. */
.heartbeat-pulse {
    width: 240px;
    height: 60px;
    margin: 0 auto;
}

.heartbeat-pulse__line {
    fill: none;
    stroke: var(--bzioup-color-pink, #da8a8b);
    stroke-width: 2;
    stroke-linejoin: round;
    stroke-linecap: round;
    /* Left-to-right "scan": the QRS spike appears to traverse the
       line in time with a slow heartbeat (~2.4s per cycle). */
    stroke-dasharray: 480;
    stroke-dashoffset: 480;
    animation: heartbeat-pulse-scan 2.4s ease-in-out infinite;
}

@keyframes heartbeat-pulse-scan {
    0%   { stroke-dashoffset: 480; }
    60%  { stroke-dashoffset: 0; }
    100% { stroke-dashoffset: -480; }
}
</style>
